/**
 * List of backoffice language slug - nextjs locale pairs
 * https://admin.leafwell.com/wp/wp-admin/admin.php?page=mlang
 */
export const locales = Object.freeze({
  en: 'en',
  es: 'es'
});
